import {
  Grid,
  ThemeProvider,
  Theme,
  StyledEngineProvider,
  Typography,
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import React, { ReactElement } from 'react';
import { BaseTheme } from '../../../BeaconTheme';

export interface ICreateNotation {
  name: string;
  children: ReactElement | ReactElement[];
  reset: () => void;
}

const CreateNotation = (props: ICreateNotation) => {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={BaseTheme}>
        <Grid container direction="column">
          <Grid item style={{ marginBottom: '1em' }}>
            <ArrowBackIosNewIcon
              aria-label="Back"
              role="button"
              aria-hidden={false}
              onClick={props.reset}
              onKeyPress={event => {
                if (event.key === 'Enter') props.reset();
              }}
              style={{ borderRight: '1px solid gray', color: '#06c' }}
              tabIndex={0}
            />{' '}
            <header style={{ display: 'inline-block' }}>
              <Typography variant="h4">Create {props.name}</Typography>
            </header>
          </Grid>
          <Grid item>{props.children}</Grid>
        </Grid>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default CreateNotation;
